import React from 'react';
import { ChartBar, HandCoins, MagnifyingGlass, Recycle, Sparkle } from '@phosphor-icons/react';
import { Slide } from '../Slide';
import { InView } from '../InView';
import { screenshots } from '../../../data/deck';
interface Crop {
  x: number;
  y: number;
  width: number;
  height: number;
}

/** Pixel size of the supplied Control Tower screenshot. */
const SOURCE = {
  width: 2168,
  height: 1636
};
const features = [{
  key: 'see',
  title: 'See what works',
  detail: 'Across brands, countries and channels.',
  icon: ChartBar,
  crop: {
    x: 78,
    y: 632,
    width: 945,
    height: 520
  },
  alt: 'Snakker Brand Intelligence overview: markets assessed, products tracked and gap severity by market'
}, {
  key: 'learn',
  title: 'Learn faster',
  detail: 'Apply success from one market to another.',
  icon: Sparkle,
  crop: {
    x: 1128,
    y: 640,
    width: 950,
    height: 505
  },
  alt: 'Snakker Brand Intelligence product view with a world map of gap severity and root-cause breakdown'
}];
const benefits = [{
  title: 'Reuse more',
  detail: 'Adapt instead of rebuild.',
  icon: Recycle
}, {
  title: 'Spot opportunities',
  detail: 'Identify where proven ideas can travel.',
  icon: MagnifyingGlass
}, {
  title: 'Build buying power',
  detail: 'More volume creates lower unit cost.',
  icon: HandCoins
}];
export function CompoundSlide() {
  return <Slide id="compound" data-id="element-237" data-mp="2p6chtlzwqdqw">
      <div className="grid items-end gap-8 lg:grid-cols-[minmax(0,1fr)_440px] lg:gap-16" data-id="element-238" data-mp="2p6maxig9110t">
        <InView data-id="element-239" data-mp="2k6rkth4asfgt">
          <p className="font-heading text-[18px] italic text-[rgba(1,51,43,0.5)]" data-id="element-240" data-mp="2k67zrrjcpayk">
            “Snakker seems to be popping up everywhere.”
          </p>
          <h2 className="mt-4 font-heading text-[44px] leading-[0.95] tracking-[-0.035em] text-background sm:text-[60px] xl:text-[70px]" data-id="element-241" data-mp="2g7ioq5lsc5i3">
            Good. Now let’s make that
            <span className="block text-[rgba(1,51,43,0.42)]" data-id="element-242" data-mp="edjfdps83y81">activity compound.</span>
          </h2>
        </InView>
        <InView delay={0.1} data-id="element-243" data-mp="9ddkm0qnpvlq">
          <p className="border-l-2 border-primary pl-5 font-body text-[14.5px] leading-[1.7] text-[rgba(1,51,43,0.65)]" data-id="element-244" data-mp="sjbabuqyai5s">
            <span className="text-background" data-id="element-245" data-mp="xbl79uqhgihk">
              The Control Tower connects independent local activity. The digital team sees
              what’s working and proactively recommends
            </span>{' '}
            — local teams keep control of their campaigns and budgets.
          </p>
        </InView>
      </div>

      <div className="mt-12 grid gap-5 lg:grid-cols-2" data-id="element-246" data-mp="1c8lubkxqbp9p">
        {features.map((feature, i) => {
        const Icon = feature.icon;
        return <InView key={feature.key} delay={0.15 + i * 0.1} y={26} data-id="element-247" data-mp="12afois8sxyzk" data-mpi={i}>
              <figure className="h-full rounded-[28px] bg-[#EFECE4] p-5 sm:p-6" data-id="element-248" data-mp="178qzj6au2fjd">
                <div className="flex items-center gap-4" data-id="element-249" data-mp="17atwybebfay4">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[14px] bg-background text-primary" data-id="element-250" data-mp="3myu49ir0917h">
                    <Icon size={22} aria-hidden="true" data-id="element-251" data-mp="3rwvi9p9kqac3" />
                  </span>
                  <div data-id="element-252" data-mp="3kdw2dtlbn0xh">
                    <span className="block font-body text-[12px] font-semibold uppercase tracking-[0.2em] text-background" data-id="element-253" data-mp="3kha4d0q2p84e">
                      {feature.title}
                    </span>
                    <span className="mt-0.5 block font-body text-[13.5px] text-[rgba(1,51,43,0.6)]" data-id="element-254" data-mp="3te1901ioxval">
                      {feature.detail}
                    </span>
                  </div>
                </div>
                <div className="mt-5 overflow-hidden rounded-[16px] bg-white p-2 ring-1 ring-[rgba(1,51,43,0.08)]" data-id="element-255" data-mp="30p3pxw6nnugs">
                  <CroppedShot crop={feature.crop} alt={feature.alt} data-id="element-256" data-mp="3agzplboe3sn4" />
                </div>
              </figure>
            </InView>;
      })}
      </div>

      <ul className="mt-5 grid gap-5 md:grid-cols-3" data-id="element-257" data-mp="35p89jv2v15b8">
        {benefits.map((benefit, i) => {
        const Icon = benefit.icon;
        return <InView key={benefit.title} delay={0.3 + i * 0.06} data-id="element-258" data-mp="2d2njcxy4ez99" data-mpi={i}>
              <li className="flex h-full items-center gap-4 rounded-[22px] bg-white px-5 py-5 ring-1 ring-[rgba(1,51,43,0.08)]" data-id="element-259" data-mp="2d018opfxo3mt">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary text-background" data-id="element-260" data-mp="2vn5tqwvmt6s6">
                  <Icon size={18} weight="bold" aria-hidden="true" data-id="element-261" data-mp="30m0gub0mthi3" />
                </span>
                <span data-id="element-262" data-mp="35eabu5glt7r8">
                  <span className="block font-body text-[12px] font-semibold uppercase tracking-[0.18em] text-background" data-id="element-263" data-mp="35etkevkd6jsl">
                    {benefit.title}
                  </span>
                  <span className="mt-0.5 block font-body text-[13px] text-[rgba(1,51,43,0.6)]" data-id="element-264" data-mp="3eclyxxi9hnex">
                    {benefit.detail}
                  </span>
                </span>
              </li>
            </InView>;
      })}
      </ul>
    </Slide>;
}
function CroppedShot({
  crop,
  alt
}: {
  crop: Crop;
  alt: string;
}) {
  return <div className="relative overflow-hidden rounded-[10px]" style={{
    aspectRatio: `${crop.width} / ${crop.height}`
  }} data-id="element-265" data-mp="1tybz9rm7w3l9">
      <img src={screenshots.controlTower} alt={alt} className="absolute block max-w-none" style={{
      width: `${SOURCE.width / crop.width * 100}%`,
      left: `-${crop.x / crop.width * 100}%`,
      top: `-${crop.y / crop.height * 100}%`
    }} data-id="element-266" data-mp="b490spimlym6" />
    </div>;
}